import React from 'react';
import './GameUI.css';

const Player = {
  NONE: 0,
  RED: 1,
  YELLOW: 2
};

const GameUI = ({ 
  currentPlayer, 
  gameState, 
  gameMode, 
  playerNames,
  gameTime,
  isThinking,
  isMyTurn,
  onlinePlayerRole,
  onAction 
}) => {
  const getPlayerName = (player) => {
    if (gameMode === 'pvc') {
      return player === Player.RED ? playerNames.red : 'Bot';
    } else if (gameMode === 'online') {
      if (player === Player.RED) {
        return onlinePlayerRole === 'red' ? 'You' : 'Opponent';
      } else {
        return onlinePlayerRole === 'yellow' ? 'You' : 'Opponent';
      }
    }
    return player === Player.RED ? playerNames.red : playerNames.yellow;
  };

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    const ms = Math.floor((milliseconds % 1000) / 10); // Show centiseconds (0-99)
    return `${mins}:${secs.toString().padStart(2, '0')}:${ms.toString().padStart(2, '0')}`;
  };

  const getCurrentPlayerDisplay = () => {
    if (isThinking) {
      return 'Bot is thinking...';
    }
    if (gameMode === 'online') {
      if (isMyTurn) {
        return 'Your Turn!';
      } else {
        return 'Opponent\'s Turn';
      }
    }
    return `${getPlayerName(currentPlayer)} Turn!`;
  };

  return (
    <div className="game-ui">
      {/* Top controls bar */}
      <div className="top-controls">
        <button 
          className="control-btn pause-btn"
          onClick={() => onAction('pause')}
          disabled={isThinking}
        >
          Pause
        </button>
        
        <div className="game-title-small">
          <h2>Connect 4</h2>
        </div>
        
        <button 
          className="control-btn exit-btn"
          onClick={() => onAction('exit')}
          disabled={isThinking}
        >
          Back
        </button>
      </div>

      {/* Current player indicator */}
      <div className="current-player-section">
        <div className="player-turn-text">
          <h3 className={`turn-text ${currentPlayer === Player.RED ? 'red' : 'yellow'}`}>
            {getCurrentPlayerDisplay()}
          </h3>
        </div>
      </div>

      {/* Game info */}
      <div className="game-info-bar">
        <div className="game-stats">
          <span className="stat-item">Time: {formatTime(gameTime)}</span>
          <span className="stat-item">
            Mode: {gameMode === 'pvc' ? 'vs Computer' : gameMode === 'online' ? 'Online' : 'vs Player'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GameUI;
